import { render, staticRenderFns } from "./OcurrenciaYEfectos.vue?vue&type=template&id=a58fba88"
import script from "./OcurrenciaYEfectos.vue?vue&type=script&lang=js"
export * from "./OcurrenciaYEfectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports